import { CSSProperties, useMemo } from 'react';
import { useBreakPoint } from '../../hooks/useBreakPoint';

export const companyListRowSections = ['name', 'location', 'year', 'employees', 'turnover', 'actions', 'flags'] as const;

export const hideSectionsInTablet: typeof companyListRowSections[number][] = ['employees', 'turnover'];
export const hideSectionsInMobile: typeof companyListRowSections[number][] = ['location', 'year', 'employees', 'turnover'];

export const sectionWidths: Record<typeof companyListRowSections[number], null | string | number> = {
  name: null,
  location: '20%',
  year: 80,
  employees: 160,
  turnover: 160,
  actions: 104 + 24 + 8,
  flags: null,
};

export interface CompanyListRowSectionProps {
  name: string;
  title?: string | JSX.Element;
  subtitle?: string | JSX.Element;
  subtitleIcons?: string | JSX.Element;
  icon?: JSX.Element;
  endIcon?: JSX.Element;
  width?: string | number;
  right?: boolean;
  bold?: boolean;
  style?: CSSProperties;
  subsections?: CompanyListRowSectionProps[];
  onClick?: () => void;
}

/** Helper to make getting search sections easy */
export const useSearchSections = () => {
  const isMedium = useBreakPoint('medium');
  const isSmall = useBreakPoint('small');

  const hiddenSections = [];
  if (isMedium) hiddenSections.push(...hideSectionsInTablet);
  if (isSmall) hiddenSections.push(...hideSectionsInMobile);

  const sections = useMemo(() => companyListRowSections.filter((section) => !hiddenSections.includes(section)), [isMedium, isSmall]);

  return sections;
};
